import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  grid: {
    minHeight: '100vh',
  },
  paper: {
    margin: theme.spacing(3, 0, 2, 0),
    padding: theme.spacing(2),
  },
  paperDraggablePoppover: {
    position: 'fixed',
    zIndex: theme.zIndex.modal,
    margin: theme.spacing(3, 2, 2, 2),
    padding: theme.spacing(2),
  },
});
